import { render, staticRenderFns } from "./TeacherCard.vue?vue&type=template&id=b02ffd84&scoped=true&"
import script from "./TeacherCard.vue?vue&type=script&lang=js&"
export * from "./TeacherCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCard.vue?vue&type=style&index=0&id=b02ffd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02ffd84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
